module.exports = __webpack_public_path__ + "static/img/ml-txt1.b6bce7b7.png";